import { createFileRoute, notFound } from "@tanstack/react-router";
import { Lib, useAlbertineTranslation } from "albertine-shared-web";
import { FeedbackMiniApp } from "./-components/FeedbackMiniApp";
import { useFeedbackData } from "./-hooks/useFeedbackData";
import { feedbackSearchSchema } from "./-utils/feedbackSearchSchema";

export const Route = createFileRoute("/feedback/")({
    validateSearch: feedbackSearchSchema,
    component: RouteComponent,

    head: ({ match }) => {
        const { tenant, locale } = match.search;
        return {
            meta: [{ title: `Feedback - ${tenant} ${locale}` }],
        };
    },

    beforeLoad: () => {
        document.documentElement.style.setProperty("--color-body-top", "transparent");
        document.documentElement.style.setProperty(
            "--color-body-bottom",
            "var(--color-surface-default)",
        );
    },

    onError: () => {
        throw notFound();
    },
});

function RouteComponent() {
    const { data, isPending, isError } = useFeedbackData();

    if (isPending) {
        return <FeedbackLoadState state="loading" />;
    }

    if (isError || !data) {
        return <FeedbackLoadState state="error" />;
    }

    return (
        <FeedbackMiniApp
            key={`${data.request.id}:${data.booking?.id ?? ""}`}
            request={data.request}
            booking={data.booking}
        />
    );
}

function FeedbackLoadState({ state }: { state: "loading" | "error" }) {
    const t = useAlbertineTranslation();

    return (
        <div className="grid h-dvh place-items-center bg-surface-default px-24 py-safe-offset-24 text-center">
            {state === "loading" ? (
                <Lib.LoadingSpinner className="[&_svg]:size-40" />
            ) : (
                <Lib.Paragraph.Medium.Reqular.Text1>
                    {t("feedback__load_error")}
                </Lib.Paragraph.Medium.Reqular.Text1>
            )}
        </div>
    );
}
